const getRedirectURL = (path?: string) =>
  new URL(path || "", window.location.origin).href.replace(/\/+$/, "");

export default getRedirectURL;
